import React from 'react';
import { Link } from 'react-router-dom';
import { offices } from '../data/siteData';
import './Footer.css';

const Footer = () => {
  const footerLinks = {
    'Practice Areas': [
      { label: 'Corporate', to: '/services/corporate-ma' },
      { label: 'Litigation', to: '/services/litigation-disputes' },
      { label: 'Finance', to: '/services/banking-finance' },
      { label: 'Real Estate', to: '/services/real-estate' },
      { label: 'Technology', to: '/services/technology-innovation' }
    ],
    Sectors: [
      { label: 'Financial Services', to: '/sectors/financial-services' },
      { label: 'Energy', to: '/sectors/energy-infrastructure' },
      { label: 'Healthcare', to: '/sectors/healthcare-life-sciences' },
      { label: 'Technology', to: '/sectors/technology-media' }
    ],
    About: [
      { label: 'Our Firm', to: '/about' },
      { label: 'Leadership', to: '/about' },
      { label: 'Careers', to: '/careers' },
      { label: 'Diversity & Inclusion', to: '/diversity-inclusion' }
    ],
    Resources: [
      { label: 'Insights', to: '/insights' },
      { label: 'Publications', to: '/publications' },
      { label: 'Events', to: '/events' },
      { label: 'News', to: '/news' }
    ]
  };

  const socialLinks = [
    { name: 'LinkedIn', icon: 'in', href: 'https://www.linkedin.com' },
    { name: 'X', icon: 'X', href: 'https://x.com' },
    { name: 'YouTube', icon: 'YT', href: 'https://www.youtube.com' }
  ];

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="section-container">
          <div className="footer-grid">
            <div className="footer-brand">
              <h2 className="footer-logo">KINGS BRIDGE LLP</h2>
              <p className="footer-tagline">Global Excellence in Legal Services</p>
              <div className="footer-social">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.href}
                    className="social-link"
                    aria-label={social.name}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span>{social.icon}</span>
                  </a>
                ))}
              </div>
            </div>

            {Object.entries(footerLinks).map(([category, links]) => (
              <div key={category} className="footer-column">
                <h3 className="footer-column-title">{category}</h3>
                <ul className="footer-links">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to}>{link.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="footer-offices">
            <h3 className="footer-offices-title">Key Offices</h3>
            <div className="offices-list">
              {offices.map((office) => (
                <Link key={office.slug} to={`/locations/${office.slug}`} className="office-link">
                  {office.city}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="section-container">
          <div className="footer-bottom-content">
            <div className="footer-legal">
              <p>&copy; 2026 Kings Bridge LLP. All rights reserved.</p>
              <div className="footer-legal-links">
                <Link to="/privacy">Privacy Policy</Link>
                <span>|</span>
                <Link to="/terms">Terms of Use</Link>
                <span>|</span>
                <Link to="/cookies">Cookie Policy</Link>
                <span>|</span>
                <Link to="/accessibility">Accessibility</Link>
              </div>
            </div>
            <div className="footer-disclaimer">
              <p>
                Kings Bridge LLP is a global law firm with a worldwide network of offices.
                Legal services are provided by individual firms within the Kings Bridge LLP network.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
